// extracted by mini-css-extract-plugin
export default {"info":"ConfirmationStep_info__Y5o0q","action":"ConfirmationStep_action__QsdrG"};